// import alpine
import { lazyBg } from '../components/lazyBg'
import { csrfToken } from '../components/csrf-token';

import 'alpinejs'

Alpine.start();

lazyBg();
csrfToken();
